import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "rows"]

import { ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TwTextarea',
  props: {
  id: {
    type: String,
    required: false,
  },
  modelValue: {
    type: String,
    required: true,
  },
  rows: {
    type: Number,
    default: 4,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emits = __emit;
const localValue = ref(props.modelValue);

watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = newValue;
  }
);

const updateValue = (event: Event) => {
  const target = event.target as HTMLTextAreaElement;
  emits("update:modelValue", target.value);
};

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("textarea", {
    id: __props.id,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localValue).value = $event)),
    class: "mt-2 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm",
    rows: __props.rows,
    onInput: updateValue
  }, null, 40, _hoisted_1)), [
    [_vModelText, localValue.value]
  ])
}
}

})